/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { HttpService, CustomAxiosRequestConfig } from "@infrastructure/transport/httpservice";
import { AppConfig } from "@infrastructure/config/config";


export class AttachmentController {
        private disableErrorHandling: boolean = false;
        constructor(config?: CustomAxiosRequestConfig){
            this.disableErrorHandling = config && config.disableErrorHandling || false;
        }
    
        public archiveAttachment = (attachmentId: number): Promise<OperationResult<any,any>> => {
            const route = `api/Attachment/?attachmentId=${attachmentId}`;
            return HttpService.Instance.request<any,any>({
                url: HttpService.Instance.GetUrl(route, 'AttachmentController','ArchiveAttachment'),
                method: "post",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
        public archiveConsultantPortalProviderAttachment = (attachmentId: number): Promise<OperationResult<any,any>> => {
            const route = `api/Attachment/?attachmentId=${attachmentId}`;
            return HttpService.Instance.request<any,any>({
                url: HttpService.Instance.GetUrl(route, 'AttachmentController','ArchiveConsultantPortalProviderAttachment'),
                method: "post",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
        public archiveConsultantPortalClinicalNoteAttachment = (attachmentId: number): Promise<OperationResult<any,any>> => {
            const route = `api/Attachment/?attachmentId=${attachmentId}`;
            return HttpService.Instance.request<any,any>({
                url: HttpService.Instance.GetUrl(route, 'AttachmentController','ArchiveConsultantPortalClinicalNoteAttachment'),
                method: "post",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
        public getAttachmentsByAppointment = (appointmentId: number): Promise<OperationResult<ProxyModel.AttachmentViewModel[],any>> => {
            const route = `api/Attachment/?appointmentId=${appointmentId}`;
            return HttpService.Instance.request<ProxyModel.AttachmentViewModel[],any>({
                url: HttpService.Instance.GetUrl(route, 'AttachmentController','GetAttachmentsByAppointment'),
                method: "get",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
        public getAttachmentsByNonAppointment = (nonAppointmentId: number): Promise<OperationResult<ProxyModel.AttachmentViewModel[],any>> => {
            const route = `api/Attachment/?nonAppointmentId=${nonAppointmentId}`;
            return HttpService.Instance.request<ProxyModel.AttachmentViewModel[],any>({
                url: HttpService.Instance.GetUrl(route, 'AttachmentController','GetAttachmentsByNonAppointment'),
                method: "get",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
        public getMaxFileSizeAllowConfig = (): Promise<OperationResult<ProxyModel.MaxFileSizeConfigModel,any>> => {
            const route = `api/Attachment/`;
            return HttpService.Instance.request<ProxyModel.MaxFileSizeConfigModel,any>({
                url: HttpService.Instance.GetUrl(route, 'AttachmentController','GetMaxFileSizeAllowConfig'),
                method: "get",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
    
        public uploadLink = (): string => {
            const route = `api/Attachment/`;
            return `/${AppConfig.Instance.getTenant()}/${HttpService.Instance.GetUrl(route, "AttachmentController","Upload")}`;
        };
    
    
        public downloadLink = (attachmentId: number, attachmentType: number): string => {
            const route = `api/Attachment/?attachmentId=${attachmentId}&attachmentType=${attachmentType}`;
            return `/${AppConfig.Instance.getTenant()}/${HttpService.Instance.GetUrl(route, "AttachmentController","Download")}`;
        };
    
        public viewAttachmentLink = (attachmentId: number, attachmentType: number, preferBuiltinPdfViewer: boolean): string => {
            const route = `api/Attachment/?attachmentId=${attachmentId}&attachmentType=${attachmentType}&preferBuiltinPdfViewer=${preferBuiltinPdfViewer}`;
            return `/${AppConfig.Instance.getTenant()}/${HttpService.Instance.GetUrl(route, "AttachmentController","ViewAttachment")}`;
        };
    
}